import FDBRequest from "./FDBRequest.js";
class FDBOpenDBRequest extends FDBRequest {
  onupgradeneeded = null;
  onblocked = null;
  toString() {
    return "[object IDBOpenDBRequest]";
  }
}
export default FDBOpenDBRequest;